import { render, staticRenderFns } from "./ia-cliente-carteira.vue?vue&type=template&id=27f40656&scoped=true&"
import script from "./ia-cliente-carteira.vue?vue&type=script&lang=js&"
export * from "./ia-cliente-carteira.vue?vue&type=script&lang=js&"
import style0 from "./ia-cliente-carteira.vue?vue&type=style&index=0&id=27f40656&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f40656",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27f40656')) {
      api.createRecord('27f40656', component.options)
    } else {
      api.reload('27f40656', component.options)
    }
    module.hot.accept("./ia-cliente-carteira.vue?vue&type=template&id=27f40656&scoped=true&", function () {
      api.rerender('27f40656', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/components/ia-cliente-painel/ia-cliente-carteira.vue"
export default component.exports